import api from "@/services/api.service";
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'change-password',
  components: {},
  props: [],
  data () {
    return {
      caption:"Change Password",
      campaigns:[],
      formField:{old_password:'',password_confirmation:'',password:''},
      submitStatus: null,
      roles:[]
    }
  },
  computed: {

  },
  mounted () {

  },
  validations: {
    formField: {
      old_password: {
        required,minLength: minLength(6)
      },
      password:{
        required,minLength: minLength(6)
      },
      password_confirmation: {
        required,minLength: minLength(6), sameAsPassword : sameAs('password')
      },
    }
  },
  created(){
    this.getRoles();
  },
  methods: {
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },
    async getRoles() {
      let response = await api.post("role/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.data.forEach(
          function(e) {            
            this.roles.push({ value: e.id, text: e.role });
          }.bind(this)
          );
      }
    },      
    async save(){
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = true
      } else{
        let response = await api.post('users/change-password', this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if(response.status=='success'){
          this.makeToast(response.message,'Success','success');
          this.formField = {};
        }else{
          for(var error in response.errors){
            this.makeToast(response.errors[error],'Alert','danger');
          }
        }
      }
    }
  }
}


